import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Divider, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import AppsIcon from '@mui/icons-material/Apps';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// components
import { MHidden } from '../../components/@material-extend';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import Logo from '../../components/commonComponents/Logo';
import useLocalStorage from '../../hooks/useLocalStorage';
import { BackendData } from '../../utils/backendDataParser';
import ClientSelectorPopover from './ClientSelectorPopover'

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 200;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 64;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    // width: `calc(100% - ${DRAWER_WIDTH}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
  }
}

));

// ----------------------------------------------------------------------

type DashboardNavbarProps = {
  onOpenSidebar: VoidFunction;
  title: string;
  showOpenSideBarButton: boolean;
  showModuleSelectorButton: boolean;
};

export default function DashboardNavbar({ onOpenSidebar, title, showOpenSideBarButton, showModuleSelectorButton }: DashboardNavbarProps) {
  const { isCollapse } = useCollapseDrawer();
  const [clients] = useLocalStorage<BackendData[]>('clientOptions', []);
  const shouldShowClientSelector = clients.length > 1;

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` }
        })
      }}
    >
      <ToolbarStyle>
        {/* <MHidden width="lgUp"> */}

        {
          showOpenSideBarButton &&
          <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Icon icon={menu2Fill} color='#30a954' />
          </IconButton>
        }

        {/* </MHidden> */}

        {/* <Searchbar /> */}
        <Typography variant="subtitle1" sx={{ color: '#70818d', fontWeight: 'bold' }}>
          {title}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>

          {
            showModuleSelectorButton === true &&
            <IconButton to="/" component={RouterLink}>
              <AppsIcon />
            </IconButton>
          }

          {/* {shouldShowClientSelector &&  */}
          <ClientSelectorPopover />
          <LanguagePopover />
          {/* <NotificationsPopover /> */}
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
      <Divider />
    </RootStyle>
  );
}
